import React from 'react';
import {
    ChoiceList,
    TextField,
    Select,
} from '@shopify/polaris';
import { CronOptions } from '../../common/Helpers';
class OperationAutomationOptionsPane extends React.Component {

    render() {

        const executionChoices = [
            {
                label: 'Execute Manually',
                value: 'manual',
                helpText: 'Operation will be created without being executed. It can be executed manually later.',
            },
            {
                label: 'Execute at Specific Date/Time',
                value: 'dateTime',
                helpText: 'Operation will be created and executed at a specified date/time in the future.',
                renderChildren: this.renderDateTimeOptions
            },
            {
                label: 'Execute Repeatedly',
                value: 'recurring',
                helpText: 'Operation will be created and will execute on a recurring schedule.',
                renderChildren: this.renderRecurringOptions
            },
        ];

        return (<div>
            <ChoiceList
                disabled={this.props.disabled}
                choices={executionChoices}
                selected={[this.props.execution.executionChoice]}
                onChange={this.handleChoiceListChange} />
        </div>);
    }

    renderDateTimeOptions = (isSelected) => {
        if (isSelected) {
            return <TextField
                label="Execution time"
                type="datetime-local"
                onChange={this.handleExecutionTimeChange}
                value={this.props.execution.executionTime}
            />;
        }
    }

    renderRecurringOptions = (isSelected) => {
        if (isSelected) {
            return <Select
                label="Frequency"
                options={CronOptions}
                onChange={this.handleFrequencyChange}
                value={this.props.execution.executionFrequency}
            />;
        }
    }

    handleExecutionTimeChange = (value) => {

        let newExecution = JSON.parse(JSON.stringify(this.props.execution));
        newExecution.executionTime = value;

        this.props.onUpdateExecution(newExecution);
    }

    handleFrequencyChange = (value) => {

        let newExecution = JSON.parse(JSON.stringify(this.props.execution));
        newExecution.executionFrequency = value;

        this.props.onUpdateExecution(newExecution);
    }

    handleChoiceListChange = (choice) => {

        let newExecution = JSON.parse(JSON.stringify(this.props.execution));
        newExecution.executionChoice = choice[0];

        this.props.onUpdateExecution(newExecution);
    }

    componentDidMount() {
    }
}

OperationAutomationOptionsPane.defaultProps = {
}

export default OperationAutomationOptionsPane;